<template>
  <div class="container pt-5">
    <h1>{{ t("USE_YOUR_CARD_VIEW.TITLE") }}</h1>
    <p class="mt-3">
      {{ t("USE_YOUR_CARD_VIEW.DESCRIPTION") }}
    </p>

    <img :src="useAsset('img/credit-line/cl_pe_use_card.webp')" alt="card-pe" />
  </div>
  <div class="position-absolute bottom-25 right-0 left-0 w-100 px-3">
    <Button type="link" class="w-100 mb-3" @click="goToCardTutorial">
      <span> {{ t("USE_YOUR_CARD_VIEW.WHAT_IS_CARD") }} </span>
    </Button>
    <Button type="primary" class="w-100" @click="goToCards">
      {{ t("USE_YOUR_CARD_VIEW.SEE_CARDS") }}
    </Button>
  </div>
</template>

<script setup lang="ts">
import useAsset from "@/apps/credit-line/helpers/useAsset";
import Button from "@/apps/credit-line/components/Button.vue";
import { useRouter } from "vue-router";
import { useI18n } from "@/apps/credit-line/composables/useI18n";

const { t } = useI18n();
const router = useRouter();

const goToCardTutorial = () => {
  router.push({ name: "CardIntroTutorialView" });
};

const goToCards = () => {
  router.push({ name: "CreditCardDetailsView" });
};
</script>

<style lang="scss" scoped>
h1 {
  color: var(--Primary-Main-green, #007c3b);
  text-align: center;
  font-feature-settings: "liga" off, "clig" off;
  font-family: Inter, sans-serif;
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
  line-height: 26px; /* 118.182% */
}

p {
  color: var(--Typography-Text-2-ICON, #595a5a);
  text-align: center;
  font-feature-settings: "liga" off, "clig" off;

  /* Text regular-content-Page title */
  font-family: Inter, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 21px; /* 150% */
}

span {
  color: var(--Primary-Main-green, #007c3b);
  text-align: center;
  font-feature-settings: "liga" off, "clig" off;

  /* Section heading - Bottons */
  font-family: Inter, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px; /* 150% */
}
</style>
